import { render, staticRenderFns } from "./BranchesByCity.vue?vue&type=template&id=9b001704&scoped=true&"
import script from "./BranchesByCity.vue?vue&type=script&lang=ts&"
export * from "./BranchesByCity.vue?vue&type=script&lang=ts&"
import style0 from "./BranchesByCity.vue?vue&type=style&index=0&id=9b001704&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b001704",
  null
  
)

export default component.exports